<template>
    <v-menu bottom right>
        <template #activator="{on}">
            <v-btn
                icon
                v-on="on"
            >
                <v-icon large>
                    mdi-chevron-down
                </v-icon>
            </v-btn>
        </template>
        <v-list>
            <v-list-item
                data-sentry-label="Przekieruj na listę z narzutami netto"
                @click="redirectToList('configurationsCalculationsCostsNettoMarkUp')"
            >
                <v-list-item-action>
                    <v-icon>
                        mdi-chevron-right-box
                    </v-icon>
                </v-list-item-action>
                <v-list-item-title>Narzut netto</v-list-item-title>
            </v-list-item>
            <v-list-item
                data-sentry-label="Przekieruj na listę ze współczynnikami grupy produktowej"
                @click="redirectToList('configurationsCalculationsCostsProductGroupFactors')"
            >
                <v-list-item-action>
                    <v-icon>
                        mdi-chevron-right-box
                    </v-icon>
                </v-list-item-action>
                <v-list-item-title>Współczynnik grupy produktowej</v-list-item-title>
            </v-list-item>
            <v-list-item
                data-sentry-label="Przekieruj na listę z minimalnym narzutem handlowca"
                @click="redirectToList('configurationsCalculationsCostsTradersMarkUp' )"
            >
                <v-list-item-action>
                    <v-icon>
                        mdi-chevron-right-box
                    </v-icon>
                </v-list-item-action>
                <v-list-item-title>Minimalny narzut handlowca</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
import router from '@/router'
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'SelectMenu',
    methods: {
        redirectToList(route) {
            if (route !== router.currentRoute.name) {
                router.push({ name: route })
                    .catch(error => {
                        errorHandler(error)
                    })
            }
        },
    }
}
</script>
